import _slicedToArray from "/home/jenkins/jenkins_home/workspace/INSi-Consult-dev/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/home/jenkins/jenkins_home/workspace/INSi-Consult-dev/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/home/jenkins/jenkins_home/workspace/INSi-Consult-dev/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
var _marked = /*#__PURE__*/_regeneratorRuntime().mark(processQueuedAction),
  _marked2 = /*#__PURE__*/_regeneratorRuntime().mark(sendJsonCommand);
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { buffers, eventChannel } from 'redux-saga';
import { actionChannel, call, put, select, take, takeEvery, delay, race } from 'redux-saga/effects';
import { dmpconnectActionConstants } from '../constants';
import { dmpCommandFailure, dmpCommandFailureContextualized, dmpCommandStartContextualized, dmpCommandStopped, dmpCommandSuccess, dmpCommandSuccessContextualized, dmpCommandTooLong, dmpRemoteCommandFailure, dmpRemoteCommandFailureContextualized, dmpRemoteCommandStart, dmpRemoteCommandSuccess, dmpRemoteCommandSuccessContextualized, dmpSynchronousCommandFailure, dmpSynchronousCommandSuccess } from '../actions/dmpconnectActions';
import { restFormatResponse } from '../actions/config/restCommandParams';
import { softwareErrors, errorTypes, createError } from '../errors';
import CustomWebsocket from '../utils/customWebsocket';
import { getDmpConnectJSHost, getDmpConnectJSPort, getDmpConnectJSProtocol } from '../helpers/accessors';

/**
 * Setup a new websocket to DMPConnectJS
 * @param hostname
 * @param port
 * @returns {CustomWebsocket}
 */
export var setupCustomSocket = function setupCustomSocket(hostname, port) {
  if (!Object.prototype.hasOwnProperty.call(window, 'WebSocket')) {
    // TODO manage error
  }
  return new CustomWebsocket("".concat(hostname, ":").concat(port));
};
export var setupSocket = function setupSocket(hostname, port) {
  if (!Object.prototype.hasOwnProperty.call(window, 'WebSocket')) {
    // TODO manage error
  }
  return new WebSocket("".concat(hostname, ":").concat(port));
};
var sockets = [];
var getSocket = function getSocket(groupName) {
  return sockets[groupName] || undefined;
};
var setSocket = function setSocket(socket, groupName) {
  sockets[groupName] = socket;
};

/**
 * Websocket channel
 * @param command
 * @param context
 * @param persistent
 * @returns {EventChannel<any>}
 */
export var websocketChannel = function websocketChannel(command) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var persistent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _ref, _ref$section, section, groupName, existingSocket, dmpcjsProtocol, dmpcjsHost, dmpcjsPort, socket, channel;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref = context || {}, _ref$section = _ref.section, section = _ref$section === void 0 ? null : _ref$section;
          groupName = section || command.s_commandName; // close already running socket
          if (!persistent && command.multipleCalls === false) {
            existingSocket = getSocket(groupName);
            if (existingSocket !== undefined) {
              existingSocket.cancel();
            }
          }
          _context.next = 5;
          return select(getDmpConnectJSProtocol);
        case 5:
          dmpcjsProtocol = _context.sent;
          _context.next = 8;
          return select(getDmpConnectJSHost);
        case 8:
          dmpcjsHost = _context.sent;
          _context.next = 11;
          return select(getDmpConnectJSPort);
        case 11:
          dmpcjsPort = _context.sent;
          socket = setupCustomSocket("".concat(dmpcjsProtocol, "://").concat(dmpcjsHost), dmpcjsPort);
          channel = eventChannel(function (emit) {
            socket.configEventHandlers(emit, command, persistent);
            return function () {
              socket.close();
            };
          });
          if (!persistent && command.multipleCalls === false) {
            setSocket(socket, groupName);
          }
          return _context.abrupt("return", channel);
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })();
};
var checkType = function checkType(type, value) {
  switch (type) {
    case 'array':
      return Array.isArray(value);
    case 'string':
      return typeof value === 'string' || value instanceof String;
    case 'number':
      return typeof value === 'number' && Number.isFinite(value);
    case 'object':
      return value && typeof value === 'object' && value.constructor === Object;
    default:
      return true;
  }
};
var checkExpectedResult = function checkExpectedResult(expected, result) {
  return expected.reduce(function (checks, _ref2) {
    var name = _ref2.name,
      type = _ref2.type;
    if (Object.prototype.hasOwnProperty.call(result, name)) {
      if (!checkType(type, result[name])) {
        checks[name] = "expected type ".concat(type); // eslint-disable-line no-param-reassign
      }
    } else {
      checks[name] = 'expected in the result'; // eslint-disable-line no-param-reassign
    }

    return checks;
  }, {});
};
var handleWSResponse = function handleWSResponse(message, action, synchronous) {
  var retries = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var command, context, silentError, expected, _context$remote, remote, _context$noRetries, noRetries, failureFunc, successFunc, sendFunc, failureContextualizedFunc, successContextualizedFunc, stop, returnError, error, forceSilent, checks;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          command = action.command, context = action.context, silentError = action.silentError, expected = action.expected;
          _context$remote = context.remote, remote = _context$remote === void 0 ? false : _context$remote, _context$noRetries = context.noRetries, noRetries = _context$noRetries === void 0 ? false : _context$noRetries;
          failureFunc = dmpCommandFailure;
          successFunc = dmpCommandSuccess;
          sendFunc = sendCommand;
          failureContextualizedFunc = dmpCommandFailureContextualized;
          successContextualizedFunc = dmpCommandSuccessContextualized;
          if (synchronous) {
            failureFunc = dmpSynchronousCommandFailure;
            successFunc = dmpSynchronousCommandSuccess;
            sendFunc = sendSynchronousCommand;
          } else if (remote) {
            failureFunc = dmpRemoteCommandFailure;
            successFunc = dmpRemoteCommandSuccess;
            failureContextualizedFunc = dmpRemoteCommandFailureContextualized;
            successContextualizedFunc = dmpRemoteCommandSuccessContextualized;
          }
          stop = true;
          returnError = false;
          forceSilent = false;
          if (!(message.s_status === 'error')) {
            _context2.next = 26;
            break;
          }
          returnError = true;
          forceSilent = true;
          if (!(retries >= 20 || noRetries === true)) {
            _context2.next = 19;
            break;
          }
          console.log('returnerror', retries);
          error = _objectSpread({
            i_apiErrorType: errorTypes.SoftwareErrors,
            i_apiErrorCode: softwareErrors.WEBSOCKET_ERROR
          }, message, {
            retries: retries
          });
          _context2.next = 24;
          break;
        case 19:
          console.log('ws error, retry', retries + 1);
          _context2.next = 22;
          return delay(1000);
        case 22:
          _context2.next = 24;
          return call(sendFunc, action, retries + 1);
        case 24:
          _context2.next = 33;
          break;
        case 26:
          if (!(message.s_status === 'too_long')) {
            _context2.next = 32;
            break;
          }
          _context2.next = 29;
          return put(dmpCommandTooLong(context, command));
        case 29:
          // yield put(dmpCommandTooLongContextualized(context, command));
          stop = false;
          _context2.next = 33;
          break;
        case 32:
          if (message.s_status !== 'OK') {
            returnError = true;
          } else if (expected !== undefined) {
            checks = checkExpectedResult(expected, message);
            if (Object.entries(checks).length > 0) {
              error = {
                i_apiErrorType: errorTypes.SoftwareErrors,
                i_apiErrorCode: softwareErrors.UNEXPECTED_ERROR,
                result: message,
                errors: checks
              };
              returnError = true;
            }
          }
        case 33:
          if (!stop) {
            _context2.next = 45;
            break;
          }
          if (!returnError) {
            _context2.next = 41;
            break;
          }
          _context2.next = 37;
          return put(failureFunc(error || message, context, command, forceSilent ? true : silentError));
        case 37:
          _context2.next = 39;
          return put(failureContextualizedFunc(error || message, context, command, forceSilent ? true : silentError));
        case 39:
          _context2.next = 45;
          break;
        case 41:
          _context2.next = 43;
          return put(successFunc(message, context, command));
        case 43:
          _context2.next = 45;
          return put(successContextualizedFunc(message, context, command));
        case 45:
          return _context2.abrupt("return", stop);
        case 46:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })();
};
var sendSynchronousCommand = function sendSynchronousCommand(action) {
  var retries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var command, context, silentError, _context$noRetries2, noRetries, channel, _yield$take, message, stop, wsError;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          command = action.command, context = action.context, silentError = action.silentError;
          _context$noRetries2 = context.noRetries, noRetries = _context$noRetries2 === void 0 ? false : _context$noRetries2;
          _context3.prev = 2;
          _context3.next = 5;
          return call(websocketChannel, command, context);
        case 5:
          channel = _context3.sent;
          _context3.next = 8;
          return put(dmpCommandStartContextualized(context, command));
        case 8:
          if (!true) {
            _context3.next = 20;
            break;
          }
          _context3.next = 11;
          return take(channel);
        case 11:
          _yield$take = _context3.sent;
          message = _yield$take.message;
          _context3.next = 15;
          return call(handleWSResponse, message, action, true, retries);
        case 15:
          stop = _context3.sent;
          if (!stop) {
            _context3.next = 18;
            break;
          }
          return _context3.abrupt("break", 20);
        case 18:
          _context3.next = 8;
          break;
        case 20:
          _context3.next = 37;
          break;
        case 22:
          _context3.prev = 22;
          _context3.t0 = _context3["catch"](2);
          if (!(retries >= 20 || noRetries === true)) {
            _context3.next = 32;
            break;
          }
          wsError = {
            i_apiErrorType: errorTypes.SoftwareErrors,
            i_apiErrorCode: softwareErrors.WEBSOCKET_ERROR
          };
          _context3.next = 28;
          return put(dmpSynchronousCommandFailure(wsError, context, command, silentError));
        case 28:
          _context3.next = 30;
          return put(dmpCommandFailureContextualized(wsError, context, command, silentError));
        case 30:
          _context3.next = 37;
          break;
        case 32:
          console.log('ws error catched, retry');
          _context3.next = 35;
          return delay(1000);
        case 35:
          _context3.next = 37;
          return call(sendSynchronousCommand, action, retries + 1);
        case 37:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[2, 22]]);
  })();
};

/**
 * Send asynchronous command to DMPConnectJS
 * @param action
 * @returns {IterableIterator<CallEffect|TakeEffect|PutEffect<{data, context, type, command}>>}
 */
var sendCommand = function sendCommand(action) {
  var retries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var command, context, silentError, expected, _context$remote2, remote, channel, _yield$take2, message, stop, wsError;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          command = action.command, context = action.context, silentError = action.silentError, expected = action.expected;
          _context$remote2 = context.remote, remote = _context$remote2 === void 0 ? false : _context$remote2;
          _context4.prev = 2;
          _context4.next = 5;
          return call(websocketChannel, command, context);
        case 5:
          channel = _context4.sent;
          if (!remote) {
            _context4.next = 11;
            break;
          }
          _context4.next = 9;
          return put(dmpRemoteCommandStart(context, command));
        case 9:
          _context4.next = 13;
          break;
        case 11:
          _context4.next = 13;
          return put(dmpCommandStartContextualized(context, command));
        case 13:
          if (!true) {
            _context4.next = 25;
            break;
          }
          _context4.next = 16;
          return take(channel);
        case 16:
          _yield$take2 = _context4.sent;
          message = _yield$take2.message;
          _context4.next = 20;
          return call(handleWSResponse, message, action, false, retries);
        case 20:
          stop = _context4.sent;
          if (!stop) {
            _context4.next = 23;
            break;
          }
          return _context4.abrupt("break", 25);
        case 23:
          _context4.next = 13;
          break;
        case 25:
          _context4.next = 42;
          break;
        case 27:
          _context4.prev = 27;
          _context4.t0 = _context4["catch"](2);
          if (!(retries >= 20)) {
            _context4.next = 37;
            break;
          }
          wsError = {
            i_apiErrorType: errorTypes.SoftwareErrors,
            i_apiErrorCode: softwareErrors.WEBSOCKET_ERROR
          };
          _context4.next = 33;
          return put(dmpCommandFailure(wsError, context, command, silentError));
        case 33:
          _context4.next = 35;
          return put(dmpCommandFailureContextualized(wsError, context, command, silentError));
        case 35:
          _context4.next = 42;
          break;
        case 37:
          console.log('ws error catched, retry', _context4.t0);
          _context4.next = 40;
          return delay(1000);
        case 40:
          _context4.next = 42;
          return call(sendCommand, action, retries + 1);
        case 42:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[2, 27]]);
  })();
};
export var handleAsynchronousCommand = /*#__PURE__*/_regeneratorRuntime().mark(function handleAsynchronousCommand() {
  return _regeneratorRuntime().wrap(function handleAsynchronousCommand$(_context5) {
    while (1) switch (_context5.prev = _context5.next) {
      case 0:
        _context5.next = 2;
        return takeEvery(dmpconnectActionConstants.DMPC_SEND_COMMAND, sendCommand);
      case 2:
      case "end":
        return _context5.stop();
    }
  }, handleAsynchronousCommand);
});
export var handleCancelCommand = /*#__PURE__*/_regeneratorRuntime().mark(function handleCancelCommand(action) {
  var section, existingSocket;
  return _regeneratorRuntime().wrap(function handleCancelCommand$(_context6) {
    while (1) switch (_context6.prev = _context6.next) {
      case 0:
        section = action.context.section;
        _context6.next = 3;
        return select(getSocket, section);
      case 3:
        existingSocket = _context6.sent;
        existingSocket.cancel();
        _context6.next = 7;
        return put(dmpCommandStopped(action.context));
      case 7:
      case "end":
        return _context6.stop();
    }
  }, handleCancelCommand);
});
var prioBuffer = function prioBuffer() {
  var highPrioBuffer = buffers.expanding(5);
  var loPrioBuffer = buffers.expanding(5);
  var put = function put(action) {
    var _action$context$prior = action.context.priority,
      priority = _action$context$prior === void 0 ? false : _action$context$prior;
    if (priority) {
      highPrioBuffer.put(action);
    } else {
      loPrioBuffer.put(action);
    }
  };
  var take = function take() {
    if (!highPrioBuffer.isEmpty()) {
      return highPrioBuffer.take();
    }
    if (!loPrioBuffer.isEmpty()) {
      return loPrioBuffer.take();
    }
  };
  var flush = function flush() {
    var items = highPrioBuffer.flush();
    items.concat(loPrioBuffer.flush());
    return items;
  };
  var isEmpty = function isEmpty() {
    return highPrioBuffer.isEmpty() && loPrioBuffer.isEmpty();
  };
  return {
    put: put,
    take: take,
    flush: flush,
    isEmpty: isEmpty
  };
};
function processQueuedAction(action) {
  var _action, _action$command, mssGetUpToDatePscToken, s_login, command, mssPscToken, _s_login$split, _s_login$split2, login;
  return _regeneratorRuntime().wrap(function processQueuedAction$(_context7) {
    while (1) switch (_context7.prev = _context7.next) {
      case 0:
        _action = action, _action$command = _action.command, mssGetUpToDatePscToken = _action$command.mssGetUpToDatePscToken, s_login = _action$command.s_login, command = _objectWithoutProperties(_action$command, ["mssGetUpToDatePscToken", "s_login"]);
        if (!(mssGetUpToDatePscToken === true)) {
          _context7.next = 7;
          break;
        }
        _context7.next = 4;
        return select(function (_ref3) {
          var mssPscAccessToken = _ref3.dmpconnectMSSConfiguration.mssPscAccessToken;
          return mssPscAccessToken;
        });
      case 4:
        mssPscToken = _context7.sent;
        _s_login$split = s_login.split(':::'), _s_login$split2 = _slicedToArray(_s_login$split, 1), login = _s_login$split2[0];
        action = _objectSpread({}, action, {
          command: _objectSpread({}, command, {
            s_login: "".concat(login, ":::").concat(mssPscToken)
          })
        });
      case 7:
        return _context7.abrupt("return", action);
      case 8:
      case "end":
        return _context7.stop();
    }
  }, _marked);
}
export var handleSynchronousCommand = /*#__PURE__*/_regeneratorRuntime().mark(function handleSynchronousCommand() {
  var requestChannel, action;
  return _regeneratorRuntime().wrap(function handleSynchronousCommand$(_context8) {
    while (1) switch (_context8.prev = _context8.next) {
      case 0:
        _context8.next = 2;
        return actionChannel(dmpconnectActionConstants.DMPC_SEND_SYNCHRONOUS_COMMAND, prioBuffer());
      case 2:
        requestChannel = _context8.sent;
      case 3:
        if (!true) {
          _context8.next = 14;
          break;
        }
        _context8.next = 6;
        return take(requestChannel);
      case 6:
        action = _context8.sent;
        _context8.next = 9;
        return call(processQueuedAction, action);
      case 9:
        action = _context8.sent;
        _context8.next = 12;
        return call(sendSynchronousCommand, action);
      case 12:
        _context8.next = 3;
        break;
      case 14:
      case "end":
        return _context8.stop();
    }
  }, handleSynchronousCommand);
});
function sendHttpRequest(_ref4) {
  var type = _ref4.type,
    url = _ref4.url,
    endpoint = _ref4.endpoint,
    command = _ref4.command,
    context = _ref4.context,
    silentError = _ref4.silentError,
    jwt = _ref4.jwt;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var message, _context$remote3, remote, _yield$race, response, timeout, error, data, responseFormatter, _error, _error2, _error3, _error4;
    return _regeneratorRuntime().wrap(function _callee5$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          message = {};
          _context$remote3 = context.remote, remote = _context$remote3 === void 0 ? false : _context$remote3;
          _context9.prev = 2;
          if (!remote) {
            _context9.next = 8;
            break;
          }
          _context9.next = 6;
          return put(dmpRemoteCommandStart(context, command));
        case 6:
          _context9.next = 10;
          break;
        case 8:
          _context9.next = 10;
          return put(dmpCommandStartContextualized(context, command));
        case 10:
          _context9.next = 12;
          return race({
            response: call(fetch, "".concat(url).concat(endpoint), {
              method: 'post',
              body: JSON.stringify(command),
              headers: jwt ? {
                'Authorization': "Bearer ".concat(jwt)
              } : {}
            }),
            timeout: delay((command.i_timeout || 30) * 1000)
          });
        case 12:
          _yield$race = _context9.sent;
          response = _yield$race.response;
          timeout = _yield$race.timeout;
          if (!timeout) {
            _context9.next = 20;
            break;
          }
          error = createError(errorTypes.SoftwareErrors, softwareErrors.WEBSOCKET_TIMEOUT);
          message = _objectSpread({}, error, {
            s_status: 'KO'
          });
          _context9.next = 29;
          break;
        case 20:
          if (!(response.status > 0)) {
            _context9.next = 28;
            break;
          }
          _context9.next = 23;
          return call([response, response.json]);
        case 23:
          data = _context9.sent;
          message = data;
          if (type.indexOf('_REST_') !== -1 && message.s_status === 'OK') {
            responseFormatter = restFormatResponse[context.section] && restFormatResponse[context.section].formatter;
            if (responseFormatter) {
              message = responseFormatter(data);
            }
          }
          _context9.next = 29;
          break;
        case 28:
          if (type.indexOf('_REST_') !== -1) {
            _error = createError(errorTypes.SoftwareErrors, softwareErrors.CONNECTOR_REST_UNREACHABLE);
            message = _objectSpread({}, command, _error, {
              s_status: 'KO'
            });
          } else {
            _error2 = createError(errorTypes.SoftwareErrors, softwareErrors.DMPCONNECTJS_MISSING_OR_UNREACHABLE);
            message = _objectSpread({}, _error2, {
              s_status: 'KO'
            });
          }
        case 29:
          if (!(message.s_status === 'OK')) {
            _context9.next = 43;
            break;
          }
          if (remote) {
            _context9.next = 37;
            break;
          }
          _context9.next = 33;
          return put(dmpCommandSuccess(message, context, command));
        case 33:
          _context9.next = 35;
          return put(dmpCommandSuccessContextualized(message, context, command));
        case 35:
          _context9.next = 41;
          break;
        case 37:
          _context9.next = 39;
          return put(dmpRemoteCommandSuccess(message, context, command));
        case 39:
          _context9.next = 41;
          return put(dmpRemoteCommandSuccessContextualized(message, context, command));
        case 41:
          _context9.next = 54;
          break;
        case 43:
          if (remote) {
            _context9.next = 50;
            break;
          }
          _context9.next = 46;
          return put(dmpCommandFailure(message, context, _objectSpread({}, command, {
            endpoint: endpoint
          }), silentError));
        case 46:
          _context9.next = 48;
          return put(dmpCommandFailureContextualized(message, context, _objectSpread({}, command, {
            endpoint: endpoint
          }), silentError));
        case 48:
          _context9.next = 54;
          break;
        case 50:
          _context9.next = 52;
          return put(dmpRemoteCommandFailure(message, context, _objectSpread({}, command, {
            endpoint: endpoint
          }), silentError));
        case 52:
          _context9.next = 54;
          return put(dmpRemoteCommandFailureContextualized(message, context, _objectSpread({}, command, {
            endpoint: endpoint
          }), silentError));
        case 54:
          _context9.next = 63;
          break;
        case 56:
          _context9.prev = 56;
          _context9.t0 = _context9["catch"](2);
          if (type.indexOf('_REST_') !== -1) {
            _error3 = createError(errorTypes.SoftwareErrors, softwareErrors.CONNECTOR_REST_UNREACHABLE);
            message = _objectSpread({}, command, _error3, {
              s_status: 'KO'
            });
          } else {
            _error4 = createError(errorTypes.SoftwareErrors, softwareErrors.DMPCONNECTJS_MISSING_OR_UNREACHABLE);
            message = _objectSpread({}, _error4, {
              s_status: 'KO'
            });
          }
          _context9.next = 61;
          return put(dmpCommandFailure(message, context, _objectSpread({}, command, {
            endpoint: endpoint
          }), silentError));
        case 61:
          _context9.next = 63;
          return put(dmpCommandFailureContextualized(message, context, _objectSpread({}, command, {
            endpoint: endpoint
          }), silentError));
        case 63:
        case "end":
          return _context9.stop();
      }
    }, _callee5, null, [[2, 56]]);
  })();
}
function sendJsonCommand(action, synchronous) {
  var command, context, silentError, expected, message, _yield$race2, response, timeout, error, _error5, successActionfunction, failureActionfunction;
  return _regeneratorRuntime().wrap(function sendJsonCommand$(_context10) {
    while (1) switch (_context10.prev = _context10.next) {
      case 0:
        command = action.command, context = action.context, silentError = action.silentError, expected = action.expected;
        _context10.next = 3;
        return put(dmpCommandStartContextualized(context, command));
      case 3:
        // window.dmpConnectJsonApi.sendJsonCommand( JSON.stringify(command), (command.i_timeout || 30) * 1000 ).then
        // ( (resData ) => {
        //     const jsonResult = JSON.parse(resData)
        //
        //     console.log("Synchronous answer received.");
        //     console.log("Answer:\n" + resData + "\n");
        // });
        message = {};
        _context10.next = 6;
        return race({
          response: call(window.dmpConnectJsonApi.sendJsonCommand, JSON.stringify(command), (command.i_timeout || 30) * 1000),
          timeout: delay((command.i_timeout || 30) * 1000)
        });
      case 6:
        _yield$race2 = _context10.sent;
        response = _yield$race2.response;
        timeout = _yield$race2.timeout;
        if (timeout) {
          error = createError(errorTypes.SoftwareErrors, softwareErrors.WEBSOCKET_TIMEOUT);
          message = _objectSpread({}, error, {
            s_status: 'KO'
          });
        } else {
          try {
            message = JSON.parse(response);
          } catch (e) {
            _error5 = createError(errorTypes.SoftwareErrors, softwareErrors.UNEXPECTED_ERROR);
            message = _objectSpread({}, _error5, {
              message: e.message,
              s_status: 'KO'
            });
          }
        }
        if (!(message.s_status === 'OK')) {
          _context10.next = 18;
          break;
        }
        if (synchronous) {
          successActionfunction = dmpSynchronousCommandSuccess;
        } else {
          successActionfunction = dmpCommandSuccess;
        }
        _context10.next = 14;
        return put(successActionfunction(message, context, command));
      case 14:
        _context10.next = 16;
        return put(dmpCommandSuccessContextualized(message, context, command));
      case 16:
        _context10.next = 23;
        break;
      case 18:
        if (synchronous) {
          failureActionfunction = dmpSynchronousCommandFailure;
        } else {
          failureActionfunction = dmpCommandFailure;
        }
        _context10.next = 21;
        return put(failureActionfunction(message, context, command, silentError));
      case 21:
        _context10.next = 23;
        return put(dmpCommandFailureContextualized(message, context, command, silentError));
      case 23:
      case "end":
        return _context10.stop();
    }
  }, _marked2);
}
export var handleHTTPCommand = /*#__PURE__*/_regeneratorRuntime().mark(function handleHTTPCommand() {
  return _regeneratorRuntime().wrap(function handleHTTPCommand$(_context11) {
    while (1) switch (_context11.prev = _context11.next) {
      case 0:
        _context11.next = 2;
        return takeEvery([dmpconnectActionConstants.DMPC_SEND_HTTP_COMMAND, dmpconnectActionConstants.DMPC_SEND_REST_COMMAND], sendHttpRequest);
      case 2:
      case "end":
        return _context11.stop();
    }
  }, handleHTTPCommand);
});
export var handleHTTPSynchronousCommand = /*#__PURE__*/_regeneratorRuntime().mark(function handleHTTPSynchronousCommand() {
  var requestChannel, action;
  return _regeneratorRuntime().wrap(function handleHTTPSynchronousCommand$(_context12) {
    while (1) switch (_context12.prev = _context12.next) {
      case 0:
        _context12.next = 2;
        return actionChannel([dmpconnectActionConstants.DMPC_SEND_HTTP_SYNCHRONOUS_COMMAND, dmpconnectActionConstants.DMPC_SEND_REST_SYNCHRONOUS_COMMAND], prioBuffer());
      case 2:
        requestChannel = _context12.sent;
      case 3:
        if (!true) {
          _context12.next = 14;
          break;
        }
        _context12.next = 6;
        return take(requestChannel);
      case 6:
        action = _context12.sent;
        _context12.next = 9;
        return call(processQueuedAction, action);
      case 9:
        action = _context12.sent;
        _context12.next = 12;
        return call(sendHttpRequest, action);
      case 12:
        _context12.next = 3;
        break;
      case 14:
      case "end":
        return _context12.stop();
    }
  }, handleHTTPSynchronousCommand);
});
export var handleJSONCommand = /*#__PURE__*/_regeneratorRuntime().mark(function handleJSONCommand() {
  return _regeneratorRuntime().wrap(function handleJSONCommand$(_context13) {
    while (1) switch (_context13.prev = _context13.next) {
      case 0:
        _context13.next = 2;
        return takeEvery([dmpconnectActionConstants.DMPC_SEND_JSON_COMMAND], sendJsonCommand);
      case 2:
      case "end":
        return _context13.stop();
    }
  }, handleJSONCommand);
});
export var handleJSONSynchronousCommand = /*#__PURE__*/_regeneratorRuntime().mark(function handleJSONSynchronousCommand() {
  var requestChannel, action;
  return _regeneratorRuntime().wrap(function handleJSONSynchronousCommand$(_context14) {
    while (1) switch (_context14.prev = _context14.next) {
      case 0:
        _context14.next = 2;
        return actionChannel(dmpconnectActionConstants.DMPC_SEND_JSON_SYNCHRONOUS_COMMAND);
      case 2:
        requestChannel = _context14.sent;
      case 3:
        if (!true) {
          _context14.next = 14;
          break;
        }
        _context14.next = 6;
        return take(requestChannel);
      case 6:
        action = _context14.sent;
        _context14.next = 9;
        return call(processQueuedAction, action);
      case 9:
        action = _context14.sent;
        _context14.next = 12;
        return call(sendJsonCommand, action, true);
      case 12:
        _context14.next = 3;
        break;
      case 14:
      case "end":
        return _context14.stop();
    }
  }, handleJSONSynchronousCommand);
});